// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"7fd0e75e","96":"948b7d3f","195":"d7b952d8","262":"fa46ee0a","432":"ea726157","799":"a312f22c","825":"bca636e9","846":"8b399e8d","947":"39c93a0b"}[chunkId] + ".chunk.js";
};